import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=ba07061c&scoped=true&"
import script from "./Auth.vue?vue&type=script&lang=js&"
export * from "./Auth.vue?vue&type=script&lang=js&"
import style0 from "./Auth.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Auth.vue?vue&type=style&index=1&id=ba07061c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba07061c",
  null
  
)

export default component.exports